jQuery(document).ready(function () {
    "use strict";
    ldEqualHeight();
});

jQuery(window).resize(function(){
    "use strict";
    ldEqualHeight();
});

function ldEqualHeight() {

    jQuery('.testimonial-slider-1__slider').each(function(){
        var highestBox = 0;

        jQuery(this).find('.testimonial-slider-1__testimonial').each(function(){
            jQuery(this).height('auto');

            if(jQuery(this).height() > highestBox){
               highestBox = jQuery(this).height();
            }
        })

        jQuery(this).find('.testimonial-slider-1__testimonial').height(highestBox);
    });
}
